/**
 * How a picker or a list names a question: its Q number from the panel's one
 * label map (shared-types `questionRefLabel`), then its title ("Q6 · How much
 * do you trust this brand?"). Two questions can share a title (the same trust
 * question before and after exposure), so the title alone cannot tell them
 * apart.
 */
export function questionNumberedTitle(
  label: string | undefined,
  title: string,
): string {
  return label ? `${label} · ${title}` : title;
}
